const checkIfDateTimeCurrent=(checkDateTime, currentDateTime) => {
 
    const [checkDate, checkTime] = checkDateTime.split('%')
    const [currentDate, currentTime] = currentDateTime.split('%');
    let dateTimeCurrent = false;

    function timeToMinutes(timeStr) {
        const [hours, minutes] = timeStr.split(":").map(Number);
        return hours * 60 + minutes;
    }
    if (checkDate === currentDate ){
        const minutes1 = timeToMinutes(checkTime); 
        const minutes2 = timeToMinutes(currentTime); 

        const diff = minutes2 - minutes1; 
        if (diff <= 30){
            dateTimeCurrent = true;
        }

    }
    return dateTimeCurrent;
}
export default checkIfDateTimeCurrent;